module.exports = __webpack_public_path__ + "static/img/ok1.0a3ffb75.svg";